import styled from '@emotion/styled';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Text, tokens, Tooltip } from '@hotjar/hotsauce';
import type { Site } from '@hotjar/site';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { TrackingCodeSnippet } from '@hotjar/webapp/features/Activation/TrackingCodeSnippet';
import { useModalTrackingCode } from '@hotjar/webapp/hooks/useModalTrackingCode';

interface ManualInstallProps {
  site: Site;
}

const Footer = styled.div`
  ${tokens.flexContainer()};
  align-items: center;
  justify-content: space-between;
  margin-top: ${tokens.spacer.x3};
`;

export const ManualInstallation = ({ site }: ManualInstallProps): JSX.Element => {
  const { t } = useTranslation();
  const track = useTrack();
  const { show: showTrackingCodeModal } = useModalTrackingCode();

  const onVerifyClick = () => {
    showTrackingCodeModal(site, 2, 'Setup Hotjar Component');
    track.click('manual installation', 'Type of Installation', {});
  };

  return (
    <>
      <TrackingCodeSnippet site={site} onVerifyClick={onVerifyClick} />
      <Footer>
        <Button
          onClick={onVerifyClick}
          loadingText={t('common:registration.select-signup-method.submit-btn-loading')}
        >
          {t('activation:tracking-code.installation.verify')}
        </Button>
        <Tooltip text="This is the site's unique identifier. You may need it to install Hotjar or to integrate with other services.">
          <Text textType="body2">
            <Trans i18nKey="activation:tracking-code.site-id" values={{ siteId: site.id }}>
              Site ID:
              <b>{{ siteId: site.id }}</b>
            </Trans>
          </Text>
        </Tooltip>
      </Footer>
    </>
  );
};
